export default "__VITE_ASSET__Dd3W_KPY__"